import { faFileArrowUp, faIcons, faImage } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "./UploadImageButton.css";

interface UploadImageButtonProps {
    text: string
    iconName: string
    idInputFile: string
    style?: any
}

const UploadImageButton = ({ text, iconName, idInputFile, style }:UploadImageButtonProps) => {
  
  const getIconImg = () => {
    switch (iconName) {
      case "folder-image":
          return (<FontAwesomeIcon icon={faImage} className="color-submit fs-18-vh mr-10"/>)
      case "file-arrow-up":
          return (<FontAwesomeIcon icon={faFileArrowUp} className="color-submit fs-18-vh mr-10" />)
      case "icons":
          return (<FontAwesomeIcon icon={faIcons} className="color-submit fs-18-vh mr-10"/>)
    
      default:
        break;
    }
  }

  return (
    <button
        onClick={(e) => {
          document.getElementById(idInputFile)?.click()
        }}
        type="button"
        className={`upload-img-btn pointer center fs-16-vh`}
        style={style}
    >
        {
          getIconImg()
        }
        <span>{text}</span>
    </button>
  )
}
//        <Icon className="icon-upload-img"/>
export default UploadImageButton